module.exports = __webpack_public_path__ + "img/logo_GI_blu_es.3a4b9294.png";